export enum TodayPlanAction {
  ClaimQuest = 'ClaimQuest',
  ClaimChest = 'ClaimChest',
  ResumeQuest = 'ResumeQuest',
  ResumeGame = 'ResumeGame',
  ResumeDeal = 'ResumeDeal',
  ProtectStreak = 'ProtectStreak',
  ViewReward = 'ViewReward',
  ChooseQuest = 'ChooseQuest',
}
